"use client";

import { t } from "@/lib/localization";
import { SpacerBlock } from "@/lib/utils/lomdaV3/types";
import { useLomdaV3Editor } from "../../store/useLomdaV3Editor";
import { SPACER_HEIGHT, clampSpacerHeight } from "../../lib/blockRegistry";
import { NumberSliderField } from "./blockAppearance";

export default function SpacerSettings({ block }: { block: SpacerBlock }) {
    const patchBlockData = useLomdaV3Editor((s) => s.patchBlockData);
    const label = t("lomda-v3-editor.spacer.height");

    return (
        <div className="flex h-9 shrink-0 items-center gap-2">
            <span className="text-sm text-foreground">{label}</span>
            <NumberSliderField
                label={label}
                value={clampSpacerHeight(block.data.height)}
                onChange={(height) =>
                    patchBlockData(block.id, "spacer", () => ({ height }))
                }
                min={SPACER_HEIGHT.min}
                max={SPACER_HEIGHT.max}
                step={SPACER_HEIGHT.step}
                unit={t("lomda-v3-editor.spacer.unit")}
            />
        </div>
    );
}
